import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  font-weight: normal;
  font-size: 0.875rem;
  gap: 0.5rem;
`;
